<template>
  	<div class="top-container">
  		<div class="top-ranking">
        <a href="javascript:;" @click="$emit('changePage', 4)" >
          <img src="../../../assets/img/top-img-ranking.png">
          <span>排行榜</span>
        </a>
      </div>
  		<div class="top-table">
  			<div class="top-number">
  				<ul>
  					<li>
  						<div class="top-number-text">挑战次数</div>
  						<div class="top-number-number">{{answerNumber}}</div>
  					</li>
  					<li>
  						<div class="top-number-text">最高分数</div>
  						<div class="top-number-number">{{maxScore}}</div>
  					</li>
  					<li>
  						<div class="top-number-text">个人排名</div>
  						<div class="top-number-number">{{personRank}}</div>
  					</li>
  					<li>
  						<div class="top-number-text">团队排名</div>
  						<div class="top-number-number">{{teamRank}}</div>
  					</li>
  				</ul>
  			</div>
  			<div class="top-number-btn">
  				<a href="javascript:;" @click="$emit('changePage', 1)" >马上挑战</a>
  			</div>
  		</div>
  		<div class="top-number-explain">
  			<div class="top-number-explain-table">
  				<div class="top-number-explain-top">
  					<img src="../../../assets/img/top-img-ranking-text.png"><span>竞赛说明</span>
  				</div>
  				<div class="top-number-explain-ccontent">
  					<p>时间：{{duration}}</p>
  					<p>规则：{{info}}</p>
  				</div>
  			</div>
  		</div>
  	</div>
</template>

<script>
  import {ApiGetInfo} from '../../../net/cdjs/index.js'
  import store from '../../../vuex/store.js'
  export default {
    data: function () {
      return {
        answerNumber: 0, // 答题次数
        maxScore: 0, // 最大分数
        personRank: 0, // 个人排名
        teamRank: 0, // 团队排名
        name: '', // 竞赛活动名
        duration: '', // 活动持续时间
        startTime: 0, // 开始时间
        endTime: 0, // 结束时间
        info: '', // 活动描述
      }
    },
    store,
    methods: {
      getInfo: function () {
        const pramas = {
          id: this.$store.state.cdjsID
        }
        ApiGetInfo(pramas).then(res=>{
         if (res.code == 200) {
            this.answerNumber = res.value.answerNumber
            this.maxScore = res.value.maxScore
            this.personRank = res.value.personRank
            this.teamRank = res.value.teamRank
            this.name = res.value.name
            this.duration = res.value.duration
            this.info = res.value.info
         }
        })
      }
    },
    mounted: function () {
      this.getInfo()
    }
  }
</script>

<style scoped>
  body{
  	font:14px/1.5 "Helvetica Neue",Helvetica,Arial,"Microsoft Yahei","Hiragino Sans GB","Heiti SC","WenQuanYi Micro Hei",sans-serif;
  	margin:0;
  	padding:0;
  }
  .bgc{
  	 width:100%;
  	 height:100%;
  	 right:0;
  	top:0;
  	left:0;
  	bottom:0;
  	z-index:999;
  	background:rgba(0,0,0,0.6);
  	position: fixed;
  	overflow-y: auto;
  }
  .top-container{
  	background-image: url(../../../assets/img/top1bgimg.jpg);
  	background-repeat: no-repeat;
  	background-size: 375px 680px;
  	width: 375px;
  	height: 680px;
  	overflow: hidden;
  	margin:0 auto;
  }
  .top-ranking{
  	float: right;
  	margin-top:20px;
  }
  .top-ranking a{
  	background:#F64522;
  	text-decoration: none;
  	float: right;
  	height: 20px;
  	padding: 10px 4px;
  	padding-left: 20px;
  	border-radius: 30px 0 0 30px;

  }
  .top-ranking a:hover{
  	background:#F64522;
  	opacity: 0.9;
  }
  .top-ranking a img{
  	width: 20px;
  	height: 20px;
  }
  .top-ranking a span{
  	font-size: 14px;
  	color: #fff;
  	font-weight: 600;
  	line-height: 20px;
  	float: right;
  	margin-right: 10px;
  }
  .top-table{
  	width: 320px;
  	background: rgba(255,255,255,0.9);
  	height: 180px;
  	border-radius: 16px;
  	margin:0 auto;
  	margin-top: 265px;
  }
  .top-number{
  	width: 300px;
  	margin: 0 auto;
  }
  .top-number ul{
  	margin:0;
  	padding:0;
  	overflow: hidden;
  	padding-top: 30px;
  }
  .top-number ul li{
  	list-style-type: none;
  	float: left;
  	width: 75px;
  }
  .top-number-text{
  	font-size:12px;
  	color: #666;
  	text-align: center;
  	width: 75px;
  }
  .top-number-number{
  	font-size: 22px;
  	line-height: 2;
  	font-weight: 800;
  	color: #E50012;
  	width: 75px;
  	text-align: center;
  }
  .top-number-btn{
  	margin:0 auto;
  	width: 270px;
  	height: 48px;
  	margin-top: 15px;
  }
  .top-number-btn a{
  	float: left;
  	width: 270px;
  	height: 48px;
  	border-radius: 30px;
  	background-color: red;
  	line-height: 48px;
  	text-align: center;
  	text-decoration: none;
  	font-size: 20px;
  	color: #fff;
  	font-weight: 600;
  	background: linear-gradient(to right, #F04715, #FE7832);
  	box-shadow: 0 2px 5px 0 rgba(255, 255, 255, .5);
  }
  	.top-number-btn a:hover{
  		background: linear-gradient(to right, #F04715, #FE7832);
  		opacity: 0.9;
  	}
  .top-number-explain{
  	width: 320px;
  	    background: rgba(255,255,255,0.9);
  	    height: 180px;
  	    border-radius: 16px;
  	    margin: 0 auto;
  	    margin-top: 25px;
  		overflow: hidden;
  }
  .top-number-explain-top{
  	text-align: center;
  	margin-top: 30px;
  }
  .top-number-explain-top img{
  	width:20px;
  	height: 20px;
  	margin-right: 10px;
  }
  .top-number-explain-top span{
  	font-size:16px;
  	color: #E50012;
  	font-weight: 600;
  	line-height: 24px;
  	float: right;
  }
  .top-number-explain-top{
  	width: 100px;
  	overflow: hidden;
  	margin: 0 auto;
  	margin-top: 20px;
  }
  .top-number-explain-ccontent{
  width: 290px;
  margin: 0 auto;
  color: #555;
  font-size: 13px;
  line-height: 1.7;
  margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Cdjs/children/top.vue